import React from 'react';
import { Link } from 'react-router-dom';
import { MyUnitCodeDto } from '../../types/unit';
import { BookOpen, Play, GraduationCap } from 'lucide-react';

interface UnitCardProps {
  unit: MyUnitCodeDto;
}

const UnitCard: React.FC<UnitCardProps> = ({ unit }) => {
  const getGradeInArabic = (grade: string) => {
    switch (grade) {
      case 'Secondary1': return 'الصف الأول الثانوي';
      case 'Secondary2': return 'الصف الثاني الثانوي';
      case 'Secondary3': return 'الصف الثالث الثانوي';
      default: return grade;
    }
  };

  const getTermInArabic = (term: string) => {
    switch (term) {
      case 'First': return 'الترم الأول';
      case 'Second': return 'الترم الثاني';
      default: return term;
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-orange-500 to-orange-600 p-4 text-white">
        <div className="flex items-center justify-between mb-2">
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${
            unit.active 
              ? 'bg-green-500 text-white' 
              : 'bg-gray-500 text-white'
          }`}>
            {unit.active ? 'نشط' : 'غير نشط'}
          </span>
          <BookOpen className="w-5 h-5" />
        </div>
        <h3 className="text-lg font-bold">{unit.unitName}</h3>
      </div>
      
      {/* Content */}
      <div className="p-4">
        {/* Course info */}
        {unit.courseName ? (
          <div className="flex items-center gap-2 text-gray-600 mb-2">
            <GraduationCap className="w-4 h-4" />
            <span className="text-sm">{unit.courseName}</span>
          </div>
        ) : (
          <div className="flex items-center gap-2 text-gold-700 mb-2">
            <BookOpen className="w-4 h-4" />
            <span className="text-sm font-medium">حصة مستقلة</span>
          </div>
        )}
        
        {/* Grade and Term */}
        {(unit.grade || unit.term) && (
        <div className="flex gap-2 mb-4">
          {unit.grade && (
          <span className="px-2 py-1 bg-orange-100 text-orange-700 rounded-lg text-xs font-medium">
            {getGradeInArabic(unit.grade)}
          </span>
          )}
          {unit.term && (
          <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-lg text-xs font-medium">
            {getTermInArabic(unit.term)}
          </span>
          )}
        </div>
        )}
        
        {/* Action button */}
        <Link 
          to={`/unit-viewer/${unit.unitId}`}
          className="w-full inline-flex items-center justify-center gap-2 px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-lg font-medium text-sm transition-colors duration-200"
        >
          <span>دخول الحصة</span>
          <Play className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};

export default React.memo(UnitCard); 